import Select from "common/components/Select/Select";
import { Constants } from "constants/Constants";

export type ProcessOptionsType = (options: string[]) => {
  value: string;
  label: string;
}[];

function ProviderSelect(props: any) {
  return (
    <Select
      options={[
        { value: "local", label: "Local" },
        {
          value: Constants.LOGIN_PROVIDER,
          label:
            Constants.LOGIN_PROVIDER.charAt(0).toUpperCase() +
            Constants.LOGIN_PROVIDER.slice(1),
        },
      ]}
      {...props}
    />
  );
}

export default ProviderSelect;
